import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { generateLocalSessionId } from "@/lib/utils/hashing/hash"

const useDepictClientSessionId = () => {
    const token = useEcommerceStore(state => state.centraSession.token || "")
    return token ?? generateLocalSessionId()
}

export default useDepictClientSessionId
